import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../shared/lib/styles';
import { default as AccordionItem } from '../../../shared/components/Accordion/AccordionItemLegacy';

export interface QuestionAnswerProps {
    id?: string;
    question: string;
    answer: React.ReactNode;
}

interface FAQProps {
    faqs: QuestionAnswerProps[];
    isFirstColumn?: boolean;
    onOpen: (faq: QuestionAnswerProps) => void;
}

const StyledAccordionItem = styled(AccordionItem)<{ hideBottomBorder: boolean }>(
    ({ hideBottomBorder }) => {
        if (hideBottomBorder) {
            return css`
                @media ${media('small', 'medium')} {
                    border-bottom-width: 0 !important;
                }
            `;
        } else {
            return css``;
        }
    }
);

const FAQs = ({ faqs, isFirstColumn = false, onOpen }: FAQProps) => (
    <>
        {faqs.map((faq, index) => {
            const { answer, question } = faq;
            const isLastItem = faqs.length - 1 == index;

            return (
                <StyledAccordionItem
                    key={index}
                    title={question}
                    hideBottomBorder={isFirstColumn && isLastItem}
                    onOpen={() => onOpen(faq)}
                >
                    {answer}
                </StyledAccordionItem>
            );
        })}
    </>
);

export default FAQs;
